var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content_center"},[_vm._v(" กำลังโหลด... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }